export const session = {
  SESSION_VALUE: "state_session",
  SESSION_ON: "on",
  SESSION_OFF: "off",
  SESSION_TOKEN: "Token",
  SESSION_ID_USER: "idUser"
};